var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isRouterAlive
        ? _c(
            "keep-alive",
            { attrs: { include: _vm.keepAliveList } },
            [
              _vm.$route.meta.keepAlive
                ? _c("router-view", { staticClass: "routerHolder" })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      !_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }